import SvgIcon from '@mui/material/SvgIcon';


const EtherscanLogo
 = () => {
  return (
    <SvgIcon>
        <svg
          fill="white"
          width="29"
          height="29"
          viewBox="0 0 35 35"
          version="1.1"
          id="svg20"
          xmlns="http://www.w3.org/2000/svg">
          <g
            clipPath="url(#clip0_3340_1171)"
            id="g13">
            <mask
              id="mask0_3340_1171"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="536"
              height="122">
              <path
                d="M 535.015,0 H 0 v 121.639 h 535.015 z"
                fill="#ffffff"
                id="path2" />
            </mask>
            <path
              id="path7"
              d="M 14.317473,0.27842742 C 12.32081,0.30213977 10.35138,0.74221102 8.5346628,1.5708713 6.7179225,2.3995293 5.0941151,3.5982996 3.7672778,5.0905226 2.4404429,6.5827455 1.4398649,8.3356114 0.82931866,10.23679 c -0.61054458,1.901157 -0.81788285,3.90908 -0.60796489,5.894817 0.20991774,1.985736 0.83209743,3.905682 1.82666023,5.637156 0.173256,0.298677 0.4281338,0.541764 0.7347202,0.700612 0.3065817,0.158848 0.652127,0.227059 0.9960668,0.196356 0.3842007,-0.03374 0.8628955,-0.08209 1.4316443,-0.14888 0.2475828,-0.02811 0.476051,-0.14607 0.6420739,-0.331868 0.1660463,-0.185775 0.2579075,-0.426072 0.25812,-0.675261 L 6.110178,13.902095 c 2.37e-5,-0.160287 0.032045,-0.318928 0.093569,-0.466921 0.061524,-0.148015 0.1514257,-0.282411 0.265034,-0.395476 0.1136318,-0.113065 0.2485599,-0.202836 0.3968594,-0.263652 0.1482995,-0.06079 0.3070936,-0.09154 0.4673817,-0.09079 l 2.0271642,0.0064 c 0.3231958,0 0.6333986,0.128683 0.8619367,0.35722 0.228562,0.228562 0.356759,0.538257 0.356759,0.861476 v 7.665243 c 0.228208,-0.06772 0.521398,-0.139735 0.842116,-0.215252 0.22278,-0.05233 0.421139,-0.178763 0.563255,-0.358143 0.142093,-0.179356 0.219449,-0.401245 0.219402,-0.63009 v -9.508451 c 0,-0.323243 0.128681,-0.632891 0.35722,-0.861476 0.228538,-0.2285844 0.538232,-0.3571482 0.861475,-0.3572189 h 2.031314 c 0.323218,7.07e-5 0.633398,0.1286345 0.861935,0.3572189 0.228538,0.228585 0.35676,0.538233 0.35676,0.861476 v 8.82494 c 0,0 0.508547,-0.205745 1.003901,-0.414835 0.184006,-0.07781 0.341242,-0.208264 0.451711,-0.374737 0.110469,-0.166494 0.169432,-0.362077 0.169621,-0.561872 V 7.8173762 c 0,-0.3231721 0.128269,-0.6333984 0.356759,-0.8619364 0.228491,-0.2285615 0.538304,-0.356688 0.861476,-0.3567588 h 2.031312 c 0.32322,0 0.632914,0.1282209 0.861476,0.3567588 0.228538,0.228538 0.35722,0.5387171 0.35722,0.8619364 V 16.48053 c 1.760997,-1.276264 3.545686,-2.811503 4.961895,-4.657223 0.205552,-0.267903 0.341201,-0.58218 0.395479,-0.915405 0.05428,-0.333202 0.02539,-0.674944 -0.08435,-0.9942222 C 27.383262,8.0275569 26.341144,6.2991246 24.979214,4.8388556 23.617284,3.3785628 21.965688,2.2187966 20.129784,1.4335146 18.293881,0.64823496 16.314136,0.25471523 14.317473,0.27842742 Z M 28.821975,13.605257 C 23.578393,21.425675 13.896508,25.081871 6.06639,26.195062 l -4.612e-4,0.0015 c 2.1410217,1.55757 4.6713452,2.492185 7.3107892,2.701041 2.639468,0.20862 5.285161,-0.316612 7.644502,-1.5183 2.359341,-1.201689 4.340406,-3.032521 5.723812,-5.290078 1.383168,-2.257627 2.114988,-4.853909 2.11428,-7.501614 0,-0.330393 -0.01539,-0.657272 -0.03733,-0.982238 z" />
          </g>
          <defs
            id="defs18">
            <clipPath
              id="clip0_3340_1171">
              <rect
                width="536"
                height="122"
                fill="#ffffff"
                id="rect15"
                x="0"
                y="0" />
            </clipPath>
          </defs>
        </svg>

    </SvgIcon>
  );
};
export default EtherscanLogo
;

